module.exports = __webpack_public_path__ + "img/goods13.7ca2af48.jpg";